import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  ViewChild,
} from "@angular/core";
import { TranslationService } from "./i18n/translation.service";
import { locale as enLang } from "./i18n/vocabs/en";
import { locale as arLang } from "./i18n/vocabs/ar";
import { PlatformService } from "./services/platform.service";
import { ResizeService } from "./services/resize.service";
import { ScrollService } from "./services/scroll.service";
import "default-passive-events";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { SharedService } from "./services/shared.service";
import { Location } from "@angular/common";
import { Subscription } from "rxjs";
import { PreviousRouteService } from "./services/previous-route.service";
import { logMessage } from "./helpers/logs";
import { environment } from "src/environments/environment";
import { RouteLocalizationPipe } from "./pipes/route-localization.pipe";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  isDefaultLayoutEnabled: boolean = true;
  @ViewChild("header") header!: any;
  @ViewChild("footer") footer!: any;
  private lastScrollY = typeof window !== "undefined" ? window.scrollY : 0;
  @ViewChild("btnSpecialCaseMain") btnSpecialCaseMain!: ElementRef;
  @ViewChild("btnSpecialCaseMainGlobal") btnSpecialCaseMainGlobal!: ElementRef;
  btnSpecialCaseURLGlobal: any = {
    url: "",
    queryParams: [],
  };
  btnSpecialCaseURL: any = {
    url: "static",
    queryParams: [],
  };
  previousRoute: any;
  isMobile: boolean = false;
  @HostBinding("style.--primary-color") primaryColor = "#00904A";
  pageType: string = "woqod"; //woqod //fahes
  isPaddingEnabled: boolean = false;
  private routerEventsSubscription: Subscription;
  lang: string = "en";

  constructor(
    private translate: TranslateService,       
    private translationService: TranslationService,
    public platformService: PlatformService,
    private resizeService: ResizeService,
    private scrollService: ScrollService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private location: Location,
    private PreviousRouteService: PreviousRouteService,
    private routeLocalizationPipe: RouteLocalizationPipe
  ) {

    this.sharedService.redirectObj$.subscribe((data: any) => {    
      if(data){
        
        this.btnSpecialCaseURLGlobal = data;
        setTimeout(() => {
          if (!this.btnSpecialCaseMainGlobal?.nativeElement) return;
          this.btnSpecialCaseMainGlobal.nativeElement.click();
          setTimeout(() => {
            this.btnSpecialCaseURL = {
              url: "",
              queryParams: [],
            };
          });
        });

      }
    });

    this.removeUnusedTopUpAmount();
    this.translationService.loadTranslations(enLang, arLang);
    const newURL = this.translationService.setLanguageLanding();

    if (newURL) {
      const urlData = this.parseRelativeURL(newURL);
      this.btnSpecialCaseURL = {
        url: urlData.baseUrl,
        queryParams: urlData.queryParams,
      };
      this.setBTNSpecialCase();
    } else {
      this.btnSpecialCaseURL = {
        url: "",
        queryParams: [],
      };
    }
    this.handleRequiredPage();
    this.routerEventsSubscription = this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {

          const cancelPage = (event?.url || '').indexOf("payment-cancel") !== -1;
          const confirmPage = (event?.url || '').indexOf("payment-confirm") !== -1;
          if(cancelPage || confirmPage){
            this.sharedService.enableFullLoader();
          }

          // https://localhost:4200/en/payment-cancel
          
          this.handleRequiredPage();
          this.handleDashboardLayout();
          this.clearStoredDataRetail();          
          this.PreviousRouteService.saveCurrentURL(
            event?.urlAfterRedirects || ""
          );
          setTimeout(() => {
            // this.checkFooterVisibility();
          });
          //
          if (!this.isMobile) this.bindConsent();
          this.translationService.setLanguageBackBTN(this.lang);
        }
      }
    );

    this.handleMobilePages();

    if (!this.isMobile) {
      this.resizeService.initializeResizeEvent();
      this.scrollService.initializeScrollEvent();
      this.scrollToTopOnRoute();
      this.updatePageType(this.location.path());
    }
  }

  handleRequiredPage(){
    let userDetailsJSON: any = null;
    if(typeof window !== "undefined"){
      try {
        const userDetails = localStorage.getItem('USER');
        userDetailsJSON = userDetails ? JSON.parse(userDetails) : null;
      } catch {
        userDetailsJSON = null;
      }

      const isUserLoggedIn = !!userDetailsJSON;
      // console.log("isUserLoggedIn", isUserLoggedIn);
      
      const url = this.location.path();

      
      if(isUserLoggedIn && url.indexOf("/my-profile-required") === -1){
        // console.log(1);
        
        if(
          (isUserLoggedIn && !userDetailsJSON?.isRegistered && userDetailsJSON?.isRegistrationMandatory) || 
          (!userDetailsJSON?.isUpdate && userDetailsJSON?.isRegistered && userDetailsJSON?.isRegistrationMandatory)
        ){
          // const redirectUrl = `/${localStorage.getItem('LANGUAGE') || 'en'}/dashboard/my-profile-required`;            
          // setTimeout(() => {
          //   this.router.parseUrl(redirectUrl);
          // });
          this.router.navigate([this.routeLocalizationPipe.transform("dashboard/my-profile-required")]);

        }    
      }

    }
  }

  removeUnusedTopUpAmount() {
    if (typeof window !== "undefined") {
      const url = this.location.path();
      const topupA = sessionStorage.getItem("topupA");

      if (
        url.endsWith("/checkout") ||
        url.indexOf("/topup-checkout") !== -1 ||
        url.indexOf("/checkout-cyber-topup") !== -1 ||
        url.indexOf("/checkout-qpay-topup") !== -1 ||
        url.indexOf("/checkout-cyber-inspection") !== -1 ||
        url.indexOf("/checkout-qpay-inspection") !== -1
      ) {
        if (!topupA) {
          setTimeout(() => {
            this.sharedService.enableFullLoaderWithMsg(this.translate.instant('dashboard.session_expired'));
            setTimeout(() => {
              this.sharedService.disableFullLoaderWithMsg();
              this.router.navigate([this.routeLocalizationPipe.transform("")]);
            }, 3000);            
          });
        }
      } else {
        // localStorage.removeItem("topupA");
      }
    }
  }

  // Convert array to object for queryParams binding
  getQueryParams() {
    return this.btnSpecialCaseURL.queryParams.reduce((acc: any, param: any) => {
      acc[param.key] = param.value;
      return acc;
    }, {});
  }

  parseRelativeURL(relativeUrl: string) {
    const dummyDomain = "https://woqod.com";
    const urlObj: any = new URL(relativeUrl, dummyDomain);
    const baseUrl = urlObj.pathname;
    const entries = Array.from(urlObj.searchParams.entries());
    const queryParams = entries.map((item: any) => ({
      key: item?.[0] || "",
      value: item?.[1] || "",
    }));
    return { baseUrl, queryParams };
  }

  getPathAfterLang(url: string): string {
    const match = (url || "").match(/\/(ar|en)\/(.*)/);
    return match ? match[2] : ""; // Return the captured path or an empty string if no match
  }

  isStrContain(str: string, strToCompare: string) {
    return (str || "").indexOf(strToCompare || "") !== -1;
  }

  removeElement(el: any) {
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }

  // Helper: remove multiple elements by selector
  removeBySelector(selector: any, all = false) {
    if (all) {
      document.querySelectorAll(selector).forEach(this.removeElement);
    } else {
      this.removeElement(document.querySelector(selector));
    }
  }

  removeConsent() {
    // delete (window as any).setConsentBannerParams;
    delete (window as any).consentBannerUtils;
    delete (window as any).consentTuningUtils;
    delete (window as any).cookieconsent;
    delete (window as any).setConsentBannerParams;
    delete (window as any).showConsentPreferencesPopup;
    delete (window as any).CookieChangeEvent;
    delete (window as any).cookieconsent;
    delete (window as any).registerSrtiCookieSDKEvents;
    //

    // List of selectors to remove
    const elementsToRemove = [
      `link[rel="stylesheet"][href="https://cdn-prod.eu.securiti.ai/consent/cookie-consent-latest.css"]`,
      `script[src="https://cdn-prod.eu.securiti.ai/consent/cookie-consent-sdk-loader.js"]`,
      `.cmp-pref-styles`,
      `[aria-label="cookieconsent"]`,
      `.cmp-loader`,
      `script[src="https://cdn-prod.eu.securiti.ai/consent/cookie-consent-sdk-latest.js"]`,
      `.cc-bottom`,
    ];

    // Remove single elements
    elementsToRemove.forEach((selector) => this.removeBySelector(selector));

    // Extra: remove all <script> tags matching a certain src
    // removeBySelector(
    //   `script[src="https://cdn-prod.eu.securiti.ai/consent/cookie-consent-sdk-latest.js"]`,
    //   true
    // );

    const extraTag = document.querySelectorAll("script");
    extraTag.forEach((item: any) => {
      if (
        item.src ===
        "https://cdn-prod.eu.securiti.ai/consent/cookie-consent-sdk-latest.js"
      ) {
        item.parentNode.removeChild(item);
      }
    });
  }

  bindConsent() {
    const consentEle =
      typeof window !== "undefined"
        ? document.querySelector('[aria-label="cookieconsent"]')
        : null;

    if (consentEle) {
      this.removeConsent();
    }
    //
    this.lang = this.translationService.getSelectedLanguage();
    if (typeof window === "undefined") return;
    const url = window.location.href;
    if (
      url.indexOf("webview/checkout") == -1 &&
      url.indexOf("webview/save-card") == -1 &&
      url.indexOf("payment-confirm") == -1
    ) {
      const script = document.createElement("script");
      script.src =
        "https://cdn-prod.eu.securiti.ai/consent/cookie-consent-sdk-loader.js";
      //
      script.setAttribute(
        "data-tenant-uuid",
        "cd96540e-0fcf-46d5-8c34-74145122363f"
      );
      script.setAttribute(
        "data-domain-uuid",
        this.lang === "ar"
          ? "bf1fde0a-93b4-4aff-b7d0-0ff46cfa1b43"
          : "314a9f2d-c156-40aa-8f24-1c929dc7bf76"
      ); //
      script.setAttribute("data-backend-url", "https://app.eu.securiti.ai");
      script.setAttribute("data-skip-css", "false");
      script.defer = true;
      //
      if (this.lang === "ar") {
        script.addEventListener("load", () => {
          let scriptData: any = {};
          scriptData[this.sharedService.getDomainURL() + "/ar"] = "ar";
          logMessage("consent script", scriptData);
          window.setConsentBannerParams({
            overrideBannerLanguage: scriptData,
          });
        });
      }
      //
      const parentNode = document.head || document.body;
      parentNode.appendChild(script);
    }
  }

  @HostListener("window:scroll", []) onScroll() {
    // this.checkFooterVisibility();
  }

  // checkFooterVisibility() {
  //   let footerElement = this.footer?.footerElement?.nativeElement || null;
  //   const headerElement = this.header?.headerElement?.nativeElement || null;

  //   if (!footerElement || !headerElement) return;
  //   footerElement = footerElement.querySelector("footer");
  //   if (!footerElement) return;

  //   const footerRect = footerElement.getBoundingClientRect();
  //   const footerVisible = (footerRect.top + 200) < window.innerHeight;

  //   const mainEle: any = document.querySelector('#router-outlet');

  //   if (!mainEle) return;

  //   if (mainEle.offsetHeight > 400) {
  //     if (footerVisible) {
  //       headerElement.style.top = "-100%"; // Hide header
  //     } else if (window.scrollY < this.lastScrollY) {
  //       headerElement.style.top = "0"; // Show header on scroll up
  //     }
  //   } else {
  //     headerElement.style.top = "0";
  //   }

  //   this.lastScrollY = window.scrollY;
  // }

  scrollToTopOnRoute() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const prevURL = this.previousRoute || "";
        this.previousRoute = this.router.url || "";
        const currentURL = this.previousRoute || "";

        const routesToIgnoreScrolling = [
          {
            from: "/media-center/multimedia/",
            to: "/media-center/multimedia/",
          },
        ];

        const isIgnored = routesToIgnoreScrolling.some(
          (item: any) =>
            prevURL.indexOf(item.from) !== -1 &&
            currentURL.indexOf(item.to) !== -1
        );

        if (!isIgnored && typeof window !== "undefined") {
          window.scrollTo({ top: 0 });
        }
      }
    });
  }

  handleMobilePages() {
    if (typeof window !== "undefined") {
      setTimeout(() => {
        const url = window.location.href;
        if (
          url.indexOf("webview/checkout") !== -1 ||
          url.indexOf("webview/save-card") !== -1
        ) {
          const amount = +this.route.snapshot.queryParams?.amount || 0;
          const token = this.route.snapshot.queryParams?.token || "";
          if (url.indexOf("webpayment=true") === -1) this.isMobile = true;
          if (amount && token) {
            this.sharedService.enableFullLoader();
          }
        } else if (
          (url.indexOf("payment-confirm") !== -1 &&
            localStorage.getItem("mobileToken") &&
            url.indexOf("webpayment=true") === -1) ||
          (url.indexOf("payment-confirm") !== -1 &&
            url.indexOf("webpayment=true") !== -1) ||
          url.indexOf("webview/cancel-transaction") !== -1 ||
          url.indexOf("webview/payment-failure") !== -1
        ) {
          if (url.indexOf("webpayment=true") === -1) this.isMobile = true;
        }
      });
    }
  }

  ngAfterViewInit(): void {
    if (!this.isMobile) this.scrollTopOnEachRouteChange();
    this.detectAppleDevice();
  }

  scrollTopOnEachRouteChange() {
    if (this.platformService.isClient()) {
      const routerSubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updatePageType(event.urlAfterRedirects);
        }
      });
    }
  }

  updatePageType(url: string) {
    // let result = "woqod"; // default
    // const pathArray = url.split("/");

    // if (pathArray.length >= 3) {
    //   result = pathArray[2] === "fahes" ? "fahes" : pathArray[2] === "qjet" ? "qjet" : "woqod";
    // }

    // if (this.pageType !== result) {
    //   this.pageType = result;
    // }

    // Set primary color
    const newColor =
      this.pageType === "woqod"
        ? "#00904A"
        : this.pageType === "qjet"
        ? "#014A8E"
        : "#b30938";
    if (this.primaryColor !== newColor) {
      this.primaryColor = newColor;
    }

    // ✅ Set favicon based on pageType
    const iconPath =
      this.pageType === "fahes"
        ? "assets/images/logos/fahes.svg"
        : this.pageType === "qjet"
        ? "assets/images/logos/qjet-logo-white.svg"
        : "favicon.ico";

    if (typeof window !== "undefined") {
      let link: HTMLLinkElement | null =
        document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "icon");
        document.head.appendChild(link);
      }
      link.setAttribute("href", iconPath);
    }
  }

  detectAppleDevice() {
    if (typeof window === "undefined") return;
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();

    if (platform.includes("mac")) {
      document.documentElement.classList.add("ios"); // Add a class for macOS
    }

    if (/iphone|ipad|ipod/.test(userAgent)) {
      document.documentElement.classList.add("ios"); // Add a class for iOS devices (iPhones, iPads, iPods)
    }

    if (/macintosh/.test(userAgent) && "ontouchend" in document) {
      // Detect iPads running desktop-class Safari (iPadOS)
      document.documentElement.classList.add("ios");
    }
  }

  setBTNSpecialCase() {
    setTimeout(() => {
      if (!this.btnSpecialCaseMain?.nativeElement) return;
      this.btnSpecialCaseMain.nativeElement.click();
      setTimeout(() => {
        this.btnSpecialCaseURL = {
          url: "",
          queryParams: [],
        };
      });
    });
  }

  ngOnDestroy() {
    // Unsubscribe from router events to prevent memory leaks
    this.routerEventsSubscription.unsubscribe();
  }

  clearStoredDataRetail(){
    if (typeof window !== "undefined") {
      const url = window.location.href;
      if(!url) return;
      const keywordsAPC = [
        "service-inspection-date-apc/",
        "service-inspection-date-update-apc/",
        "booking-summary-apc/",
        "booking-summary-apc-update/",
      ];

      const keywordsWoqode = [
        "service-inspection-date/",
        "service-inspection-date-update/",
        "booking-summary/",
        "booking-summary-update/",
      ];      

      const foundWoqode = keywordsWoqode.some(keyword => url.indexOf(keyword) !== -1);      
      const foundAPC = keywordsAPC.some(keyword => url.indexOf(keyword) !== -1);      

      if (!foundWoqode) localStorage.removeItem('bookingpayload');
      if (!foundAPC) localStorage.removeItem('bookingpayloadapc');
    }
  }

  handleDashboardLayout() {
    if (typeof window !== "undefined") {
      const url = window.location.href;
      const isDahboardPages = url.indexOf("dashboard/") !== -1;
      if (isDahboardPages) {
        const isCurrentPageFromTheBelowPages =
          url.indexOf("dashboard/profile") !== -1 ||
          url.endsWith("/dashboard/wallet");
        this.isDefaultLayoutEnabled = isCurrentPageFromTheBelowPages;
      } else {
        this.isDefaultLayoutEnabled = true;
      }
    }
    // this.cdk.detectChanges();
  }
}
